import { Button as o } from "./button/index.js";
import { AiAction as p } from "./ai-action/index.js";
import { AiChip as e } from "./ai-chip/index.js";
import { Avatar as a } from "./avatar/index.js";
import { Badge as i } from "./badge/index.js";
import { Breadcrumb as b } from "./breadcrumbs/breadcrumb/index.js";
import { Breadcrumbs as d } from "./breadcrumbs/index.js";
import { Card as l } from "./card/index.js";
import { Checkbox as s } from "./checkbox/index.js";
import { DataGrid as u } from "./data-grid/index.js";
import { Dialog as T } from "./dialog/index.js";
import { Feedback as f } from "./feedback/index.js";
import { Hint as x } from "./hint/index.js";
import { Icon as S } from "./icon/index.js";
import { Input as h } from "./input/index.js";
import { TextArea as C } from "./text-area/index.js";
import { Label as I } from "./label/index.js";
import { Link as A } from "./link/index.js";
import { ListboxOption as L } from "./listbox/option/index.js";
import { Listbox as P } from "./listbox/index.js";
import { MenuItem as k } from "./menu/item/index.js";
import { Menu as w } from "./menu/index.js";
import { Pagination as B } from "./pagination/index.js";
import { PieChart as O } from "./pie-chart/index.js";
import { PopUpWidget as R } from "./pop-up-widget/index.js";
import { ListboxValues as v } from "./listbox/values/index.js";
import { RadioGroupOption as G } from "./radio-group/option/index.js";
import { RadioGroup as y } from "./radio-group/index.js";
import { Rating as D } from "./rating/index.js";
import { NavItem as H } from "./sidebar/nav-item/index.js";
import { SubNavItem as M } from "./sidebar/sub-nav-item/index.js";
import { Sidebar as N } from "./sidebar/index.js";
import { Skeleton as $ } from "./skeleton/index.js";
import { Step as F } from "./stepper/step/index.js";
import { StepIcon as U } from "./stepper/step-icon/index.js";
import { Stepper as V } from "./stepper/index.js";
import { Switch as W } from "./switch/index.js";
import { TableCell as j } from "./table/tcell/index.js";
import { TableHeader as q } from "./table/thead/index.js";
import { TableRow as z } from "./table/trow/index.js";
import { Table as E } from "./table/index.js";
import { TablePagination as J } from "./table-pagination/index.js";
import { TabPanel as K } from "./tabs/panel/index.js";
import { Tab as Q } from "./tabs/tab/index.js";
import { Tabs as X } from "./tabs/index.js";
import { Tag as Y } from "./tag/index.js";
import { Timer as Z } from "./timer/index.js";
import { Toast as _ } from "./toaster/toast/index.js";
import { Toaster as n } from "./toaster/index.js";
import { Tooltip as c } from "./tooltip/index.js";
function m(r, t) {
  r.define(r, {
    name: `${t.prefix}-${r.definition.name}`,
    template: r.definition.template(t),
    styles: r.definition.styles(t),
    shadowOptions: r.definition.shadowOptions,
    attributes: r.definition.attributes
  });
}
function Zr(r) {
  m(p, r), m(e, r), m(a, r), m(i, r), m(b, r), m(d, r), m(o, r), m(l, r), m(s, r), m(u, r), m(T, r), m(f, r), m(x, r), m(S, r), m(h, r), m(I, r), m(A, r), m(L, r), m(v, r), m(P, r), m(k, r), m(w, r), m(B, r), m(O, r), m(R, r), m(G, r), m(y, r), m(D, r), m(H, r), m(M, r), m(N, r), m($, r), m(F, r), m(U, r), m(V, r), m(W, r), m(j, r), m(q, r), m(z, r), m(E, r), m(J, r), m(K, r), m(Q, r), m(X, r), m(Y, r), m(C, r), m(Z, r), m(_, r), m(n, r), m(c, r);
}
export {
  m as register,
  Zr as registerComponents
};
